import {
  Breakpoints,
  Link,
  OpenInLayer,
  styled,
  TextCustom,
  useIsMobile,
} from '@vw-marketing/us-components';
import React from 'react';
import FiveStars from '../../components/five-stars';
import { AppConstants } from '../../utils/app-constants';
import {
  dealerNameReviewsLinkStyle,
  reviewsLinkStyle,
} from '../model-reviews/helpers';
import { DealerReview } from '../../typings/dealer-review';

interface DealerReviewsProps {
  reviews: DealerReview;
  onOpenReviews: () => void;
  isDealerName?: boolean;
  dealerName?: string;
}

const StyledModelReviewsContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  position: relative;
  z-index: 0;
  column-gap: 8px;
  a {
    cursor: pointer;
  }
`;
const DealerReviews: React.FC<DealerReviewsProps> = ({
  reviews,
  onOpenReviews,
  isDealerName,
  dealerName,
}) => {
  const { avg_rating, total_ratings } = reviews;
  const reviewsLabel = isDealerName
    ? dealerName
    : `${avg_rating.toFixed(1)} | ${total_ratings} reviews`;
  const textStyle = isDealerName
    ? dealerNameReviewsLinkStyle
    : reviewsLinkStyle;
  const iconSize = isDealerName ? 'default' : 'small';
  const isMobile = useIsMobile(Breakpoints.b960);
  return (
    <StyledModelReviewsContainer className="reviews-wrapper">
      {!isDealerName && (
        <FiveStars
          percent={((avg_rating || 0) / 5) * 100}
          starSize={isMobile ? '14px' : '20px'}
          starColor={'#001E50'}
          background={AppConstants.StarBackground as string}
        />
      )}
      <Link onClick={onOpenReviews} isInline>
        <TextCustom {...textStyle}>
          {isDealerName ? (
            <span className="notranslate">{reviewsLabel}</span>
          ) : (
            reviewsLabel
          )}
        </TextCustom>
        <OpenInLayer variant={iconSize} />
      </Link>
    </StyledModelReviewsContainer>
  );
};

export default DealerReviews;
